import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent shadow-xs outline-none disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:bg-brand-600 dark:data-[state=unchecked]:bg-input/80 data-[state=unchecked]:bg-neutral-300",
        "focus-visible:border-ring focus-visible:ring-ring/50",
        // Replace transition-all
        "transition-[background-color,box-shadow,border-color] duration-200 ease-in-out",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-4 rounded-full ring-0",
          "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground",
          // Thumb only translates
          "transition-transform duration-200 ease-in-out",
          "data-[state=checked]:translate-x-[calc(100%--1px)] data-[state=unchecked]:translate-x-[1px]",
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
